var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382 468 c-24 -11 -42 -21 -39 -24 4 -5 97 34 97 41 0 8 -13 4 -58 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 460 c-38 -17 -74 -29 -80 -27 -5 2 -14 -19 -20 -47 -13 -67 -40 -76 -50 -17 l-7 41 -54 0 c-51 0 -54 -1 -54 -25 0 -20 -5 -25 -25 -25 -14 0 -25 5 -25 10 0 6 -13 10 -30 10 -16 0 -30 -4 -30 -10 0 -5 -6 -10 -14 -10 -18 0 -26 -22 -26 -71 l0 -39 131 0 c71 0 150 5 173 11 41 10 45 15 71 74 15 35 37 71 50 79 22 14 25 12 89 -54 62 -64 66 -71 66 -114 0 -47 16 -64 23 -23 4 22 4 22 14 -3 10 -22 12 -23 18 -7 8 19 -12 50 -26 41 -5 -3 -9 8 -9 25 0 16 6 31 13 34 8 3 7 10 -7 23 -10 11 -15 13 -11 5 5 -9 4 -12 -3 -7 -6 4 -9 12 -7 19 3 7 -9 28 -26 47 -17 19 -27 29 -23 21 5 -9 3 -12 -5 -7 -6 4 -9 12 -5 17 6 11 -22 59 -34 59 -4 0 -38 -14 -77 -30z m-81 -84 c-3 -21 -8 -35 -11 -32 -2 2 -1 20 3 40 3 21 8 35 11 32 2 -2 1 -20 -3 -40z m231 4 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-375 -15 c0 -14 -6 -25 -13 -25 -20 0 -25 9 -20 31 8 28 33 24 33 -6z m64 -7 c7 -38 8 -38 -26 -31 -23 4 -28 11 -28 34 0 24 4 29 24 29 18 0 25 -7 30 -32z m-176 -25 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m0 -30 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 248 c-15 -15 -16 -48 -2 -48 6 0 9 3 8 8 0 4 2 15 7 25 9 22 2 30 -13 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 233 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 204 c-8 -6 -13 -19 -10 -30 3 -18 15 -19 199 -22 163 -2 198 0 202 12 3 8 0 22 -8 33 -12 16 -30 18 -191 18 -109 0 -183 -4 -192 -11z m36 -22 c2 -7 -3 -12 -12 -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z m339 -8 c-3 -4 -14 -3 -24 0 -15 6 -15 8 -3 16 16 10 39 -4 27 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle8);
export default __webpack_public_path__ + "static/media/vehicle8.b44aeef8e487a6fe4e804bb6599b4201.svg";
export { ForwardRef as ReactComponent };